// import React, { useState, useContext, createRef, useEffect } from 'react'
// import { Button, Container, Icon, Divider, Form, Grid, Header, Image, Message, Segment, Sticky, Advertisement, SegmentGroup } from 'semantic-ui-react';
// import { Link, Redirect } from 'react-router-dom';
// import { AppState } from '../../context';
// import PropType from "prop-types";
// import { makeStyles } from '@material-ui/core/styles';
// import ListSubheader from '@material-ui/core/ListSubheader';
// import List from '@material-ui/core/List';
// import ListItem from '@material-ui/core/ListItem';
// import ListItemIcon from '@material-ui/core/ListItemIcon';
// import ListItemText from '@material-ui/core/ListItemText';
// import Collapse from '@material-ui/core/Collapse';
// import ExpandLess from '@material-ui/icons/ExpandLess';
// import ExpandMore from '@material-ui/icons/ExpandMore';
// import Avatar from 'react-avatar';
// import Tasks from './Tasks'
// import CollapsableList from './CollabsableList';
// import GetMembers from './GetMembers'

// const Admin = ({ inst }) => {
//   const someContext = useContext(AppState);
//   const {
//     incompleteTasks,
//     totalTasks,
//     familyMembers,
//     admin
//   } = someContext;

//   const useStyles = makeStyles((theme) => ({
//     root: {
//       width: '100%',
//       backgroundColor: theme.palette.background.paper,
//     },
//     nested: {
//       paddingLeft: theme.spacing(4),
//     },
//   }));

//   if (admin == inst.toLowerCase()) {
//     return (
//       <CollapsableList inst={inst} />
//     )
//   }
//   else {
//     return <Redirect to={`/agency/${inst.toLowerCase()}/login`} />
//   }

// }

// Admin.propTypes = {
//   org: PropType.string.isRequired
// }

// export default Admin;



/*
^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
THIS IS THE CODE WE USED FOR THE PREVIOUS VERISON WE HAD

THIS IS THE CODE FOR THE NEW/MORE PROFESSIONAL VERSION

*/


import React, { useState, useContext, createRef, useEffect } from 'react'
import { AppState } from '../../context';
import PropType from "prop-types";
import { DataTableContainer, StyledTable } from "./styles";
import { Tooltip, Typography } from '@material-ui/core';
import AdminHeaderBar from './AdminHeader'

export default function Admin(props) {

  const [data, setData] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchValue, setSearchValue] = useState('');
  const search = ""

  const someContext = useContext(AppState);
  const {
    numberTasks,
    caregivers,
    familyMembers,
    seniors
  } = someContext;


  const columnOptions = {
    filter: true,
    sort: true
  };

  const columnOptionsfalse = {
    filter: false,
    sort: true
  };

  const columns = [
    {
      name: "name",
      label: "Elder Name",
      options: columnOptions
    },
    {
      name: "caremanager",
      label: "Care Manager",
      options: columnOptionsfalse
    },
    {
      name: "family",
      label: "Family",
      options: columnOptionsfalse
    },
    {
      name: "caregivers",
      label: "Caregiver(s)",
      options: columnOptionsfalse
    },
    {
      name: "total",
      label: "Total Tasks",
      options: columnOptions
    },
    {
      name: "incomplete",
      label: "Incomplete Tasks",
      options: columnOptions
    },
    {
      name: "notes",
      label: "Number of Notes",
      options: columnOptions
    },
  ];


  const generateData = (family) => {
    let tempData = [];
    if (family) {
      family.map(input => {
        if (input["organization"] == props.inst) {
          let seniorHook = input["seniors"] ? seniors[Object.values(input["seniors"])] : "";
          let caregiverHook = "-";
          let familyHook = "-";
          let notes = 0;
          if (input["careBool"]) {
            let temp = "";
            let tempNotes = 0;
            Object.values(input["caregivers"]).map(caregiverid => {
              temp = temp + caregivers[caregiverid]["firstName"] + " " + caregivers[caregiverid]["lastName"] + " "
              if (caregivers[caregiverid]["notes"] != "null") {
                tempNotes = tempNotes + Object.keys(caregivers[caregiverid]["notes"]).length
              }
            })
            let tempfam = ""
            if (input["secondaryFam"] != "hi") {
              Object.values(input["secondaryFam"]).map(member => {
                if (familyMembers[member]) {
                  tempfam = tempfam + familyMembers[member]["firstName"] + " " + familyMembers[member]["lastName"] + " "
                }
              })
            }
            notes = tempNotes;
            caregiverHook = temp;
            familyHook = tempfam;
          }
          tempData.push({
            caremanager: <Tooltip title={
              <React.Fragment>
                <Typography color="inherit">{"Username: " + input["id"]}</Typography>
                <Typography color="inherit">{"Password: " + input["password"]}</Typography>
              </React.Fragment>
            }>
              <div>
                {input["firstName"] + " " + input["lastName"]}
              </div>
            </Tooltip>,
            family:
              <Tooltip title={input["secondaryFam"] != "hi" ?
              Object.values(input["secondaryFam"]).map(member => {
                return(familyMembers[member] ?
                   <React.Fragment>
                  <Typography color="inherit">{"Username: " + member}</Typography>
                  <Typography color="inherit">{"Password: " + familyMembers[member]["password"]}</Typography>
                </React.Fragment>: null)
              }) : null
              }>
                <div>
                  {familyHook}
                </div>
              </Tooltip>,
            data: input,
            name: seniorHook["firstName"] + " " + seniorHook["lastName"],
            total: numberTasks(input)[0],
            caregivers: <Tooltip title={input["caregivers"]?
              Object.values(input["caregivers"]).map(member => {
                return(caregivers[member] ?
                   <React.Fragment>
                  <Typography color="inherit">{"Username: " + member}</Typography>
                  <Typography color="inherit">{"Password: " + caregivers[member]["password"]}</Typography>
                </React.Fragment>: null)
              }):null
            }>
              <div>
                {caregiverHook}
              </div>
            </Tooltip>,
            incomplete: numberTasks(input)[1],
            notes: notes
          })
        }
      });
    }

    setData(tempData);
    return tempData;
  }

  const onRowClick = (rowData, meta) => {
    const index = data[meta.dataIndex].data.id;
    const senior = data[meta.dataIndex].name;
    window.location.assign(`/${props.inst}/admin/${index}/${senior}`);
  };

  const onChangeRowsPerPage = numberOfRows => {
    setRowsPerPage(numberOfRows);
  }


  const options = {
    download: false,
    draggableColumns: {
      enabled: true
    },
    print: true,
    onRowClick: onRowClick,
    print: false,
    selectableRows: "none",
    responsive: "simple",
    onChangeRowsPerPage: onChangeRowsPerPage,
    searchText: searchValue,
    searchPlaceholder: 'Search by Elder',
    onSearchChange: (searchText) => setSearchValue(searchText),
  };

  useEffect(() => {
    if (search) {

    }
  }, [search])


  useEffect(() => {
    if (familyMembers && caregivers && seniors) {
      generateData(Object.values(familyMembers));
      // setPage(deployments.current_page);
    }
  }, [familyMembers, caregivers, seniors]);

  return (
    <div>
      <AdminHeaderBar />
      <DataTableContainer maxWidth={"lg"}>
        <StyledTable
          title={`All ${props.inst} Accounts`}
          data={data}
          columns={columns}
          options={options}
        />
      </DataTableContainer>
    </div>
  )
}

Admin.propTypes = {
  inst: PropType.string.isRequired
}